import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserDetails } from "../service/auth";
import CountdownTimer from "../components/Countdown";
import Logo from "../components/Logo";
import ConfettiBG from "../components/ConfettiBg";
import BgPattern from "../components/BgPattern";
import LoadingScreen from "../components/Loading";
import { emitLoginEvent } from "../service/db";

const Dashboard = () => {
	const [showLoading, setshowLoading] = useState(true);
	const [countdownOver, setcountdownOver] = useState(false);
	const navigate = useNavigate();
	const [URL, setUrl] = useState("");
	const [messageURL, setMessageURL] = useState("");
	const [isCopied, setIsCopied] = useState(false);
	const [name, setName] = useState("");
	const [targetYear, settargetYear] = useState(2024);
	const [total_messages, settotal_messages] = useState(0);

	useEffect(() => {
		try {
			fetchUserDetails(
				//fetch uid from auth server
				(user) => {
					console.log("s-d-one");
					emitLoginEvent(
						user.$id,
						async (resp) => {
							console.log("s-d-two");
							const { userid, pubid, target_year , total_msg } = await resp.json();
							// console.log(userid , pubid , targetYear);
							
							settargetYear(target_year);
							setUrl(window.location.origin + "/message?pubid=" + pubid);
							setMessageURL(window.location.origin + "/result?uid=" + userid);
							const [name] = user.email.split("@");
							setName(name);
							setshowLoading(false);
							settotal_messages(total_msg ?? 0);
						},
						(err) => {
							console.log("f-d-two");
							navigate("/");
						}
					);
				},
				(e) => {
					console.log("f-d-one");
					navigate("/");
				}
			);
		} catch (error) {
			navigate("/");
		}
	}, []);

	const handleCopyClick = async () => {
		try {
			await navigator.clipboard.writeText(
				`Hey, Share your thoughts anonymously with me via: \n${URL}`
			);
			setIsCopied(true);

			// Reset the "Copied" state after 2 seconds
			setTimeout(() => {
				setIsCopied(false);
			}, 2000);
		} catch (error) {
			console.error("Unable to copy text: ", error);
		}
	};

	return (
		<div className="bg-[#0b0022] h-full  text-white flex flex-col items-center justify-center relative overflow-hidden">
			<BgPattern rotate className="absolute top-0 left-0 w-full h-full opacity-30 "></BgPattern>
			<ConfettiBG></ConfettiBG>
			<LoadingScreen show={showLoading} />
			<div className="w-[50%] min-w-[350px] shadow-xl border-[3px] backdrop-blur-md border-[#22203f] flex flex-col items-center justify-center z-[1] bg-[rgba(7,14,25 , 0.5)] py-20 rounded-lg">
				<h1 className="text-[2rem] font-bold text-gray-100 ">Hii {name}</h1>
				<CountdownTimer
					targetyear={targetYear}
					onCountdownOver={() => {
						setcountdownOver(true);
					}}
				/>
				{/* <img src={require("../assets/bg2.png")} alt="bg" className="absolute h-[50%] bottom-0 right-0 opacity-70" /> */}
				<div className="relative flex flex-col justify-center items-center ">
					{/* <img className="absolute z-[0] w-full scale-y-[1.4]  opacity-10" src={require("../assets/paper2.png")} alt="paper" /> */}
					<div className="flex flex-col z-[1] items-center">
						<>
							{!countdownOver && (
								<>
									<p className="font-bold text-white">Share this URL</p>
									<div className="h-[1rem]"> </div>
									<div className="bg-[#cdcaff] min-w-[300px] w-[25%] min-h-[50px] flex items-center rounded-md p-2 overflow-hidden box-border ">
										<p className="text-black font-bold text-ellipsis overflow-hidden whitespace-nowrap w-full">{URL}</p>
										<button onClick={handleCopyClick} className={`ml-2 bg-[#6100FF] min-w-[80px] w-[25%] rounded-md p-1 outline-none hover:bg-[#3a62b2] ${isCopied ? "bg-gray-500 cursor-not-allowed" : ""}`} disabled={isCopied}>
											{isCopied ? "Copied" : "Copy"}
										</button>
									</div>
									<div className="h-[1rem]"> </div>
								</>
							)}

							{countdownOver && (
								<Link to={messageURL} className="bg-red-400  hover:bg-red-500 active:bg-red-600 text-white font-bold py-2 px-4 rounded-full">
									View Messages
								</Link>
							)}

							{!countdownOver && <p className=" font-normal text-xs text-gray-300">You can view the messages when the year ends </p>}
						</>
					</div>
				</div>
				<p className="text-xl p-4">{total_messages} messages</p>
				{/* <button type="submit" className="bg-[#6100FF] min-w-[250px] w-[25%] rounded-md p-2 outline-none focus:border-pink-500 hover:bg-[#4c00cc]" onClick={() => navigate(`/anonymous/${url}`)}>
				Go to Anonymous Message Screen
			</button> */}
			</div>

			<img className="absolute h-[70%] min-w-[600px] -left-[200px] -top-10 -z-[0] opacity-45" src={require("../assets/christmasballs.png")} alt="tree" />

			<Logo className="bottom-0 absolute z-50" />
		</div>
	);
};

export default Dashboard;
